import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { Button } from 'loyal-react'
import CardOferta from '../Card/CardOferta'
import { EmptyOffers } from '..'

import Rater from 'react-rater'
import moment from 'moment'
import InfiniteScroll from 'react-infinite-scroller'
import 'react-rater/lib/react-rater.css'
import 'react-tabs/style/react-tabs.css'
import '@loyal_template/rating.css'
import '@loyal_template/storerating.css'

class StoreTabs extends Component {
  render () {
    const { averageRating, numberOfRows } = this.props.evaluate
    const evaluateItems = this.props.evaluateItems

    return (
      <Tabs defaultIndex={0} className={`product-tabs border-color-ui-3 mt-0 mt-md-3`}>
        <div className='tabs-area draggable border-color-ui-3 border-bottom px-2 mx-0'>
          <div className='draggable-item d-inline-block px-half'>
            <TabList className='tabs-item py-3 px-0 mx-0'>
              <Tab className='item-button pos-relative d-inline-block px-2 txt-circular-black txt-lowercase txt-body color-ui-3'>
                Ofertas
              </Tab>
              <Tab className='item-button pos-relative d-inline-block px-2 txt-circular-black txt-lowercase txt-body color-ui-3'>
                Avaliações
              </Tab>
            </TabList>
          </div>
        </div>
        <TabPanel className='tabeffect row px-2 mx-0'>
          {!this.props.NotFound
            ? <InfiniteScroll
              initialLoad={false}
              pageStart={0}
              loadMore={this.props.loadItems}
              hasMore={this.props.hasMoreItems}
              loader={
                <Button loading text='Carregando' className='btn-flat' />
              }
            >
              <div className='row'>
                { this.props.offers && this.props.offers.map((product, ix) => (
                  <CardOferta {...product} offer={product} key={ix} location={false} />
                )) }
              </div>
            </InfiniteScroll>
            : <EmptyOffers />}
        </TabPanel>

        <TabPanel className='tabeffect row px-2 mx-0'>
          <div className='item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'>
            <div className='row'>
              <div className='col-12 product-rating-tablets'>
                <div className='row'>
                  <div className='col'>
                    <div className='row'>
                      <div className='col-3 product-rating'>
                        <h1 className='txt-headline'>{averageRating}</h1>
                      </div>
                      <div className='col-9 product-rating'>
                        <p>
                          <Rater total={5} rating={Math.round(averageRating)} interactive={false} />
                        </p>
                        <p>
                          média de { numberOfRows > 1 ? numberOfRows + ' avaliações' : numberOfRows + ' avaliação' }
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-md-auto product-rating'>
                    <Button
                      id={'openRatingModal'}
                      name={'openRatingModal'}
                      className='btn btn-rating-modal col-12 col-md-12 px-3'
                      text='Avaliar'
                      onClick={this.props.onRating}
                    />
                  </div>
                </div>
              </div>
              {
                evaluateItems && evaluateItems.map(function (item, index) {
                  return <div key={index} className='col-12 border-color-ui-3 border-top pt-3 mt-3 mb-3 product-rating'>
                    <div className='row'>
                      <div className='col-12'>
                        <Rater total={5} rating={item.rating} interactive={false} /> {item.participantName || ''} - { moment(item.createDate).format('DD/MM/YYYY') || ''}
                      </div>
                      <div className='col-12 d-none d-md-block px-md-1 px-2 my-1'>
                        <h4 className='txt-circular-book '>
                          {item.title}
                        </h4>
                      </div>
                      <div className='col-12 py-2 py-md-0 txt-body-sm'>
                        <p className='txt-body-sm'>{ item.comment}</p>
                      </div>
                    </div>
                  </div>
                })
              }
              <div className='col-12 border-top border-top-dotted border-color-ui-3 pt-3 pb-0'>
                <a className='cursor txt-left px-0 pt-1 txt-font-body color-brand-1 txt-body' onClick={() => this.props.handleGetEvaluate(5, (this.props.currentPage + 1))}>
                  Ver mais avaliações
                </a>
              </div>
            </div>
          </div>
        </TabPanel>
      </Tabs>
    )
  }
}

StoreTabs.propTypes = {
  offers: PropTypes.array,
  onRating: PropTypes.func,
  evaluate: PropTypes.object,
  evaluateItems: PropTypes.array,
  handleGetEvaluate: PropTypes.func,
  loadItems: PropTypes.func,
  NotFound: PropTypes.bool,
  hasMoreItems: PropTypes.bool,
  currentPage: PropTypes.number
}

export default StoreTabs



// WEBPACK FOOTER //
// ./src/features/MeuBairro/Store/StoreTabs.js